import React, { ReactNode } from 'react'

import styles from './index.module.css'

interface IMainProps {
  children: ReactNode
}

export const Main = (props: IMainProps) => {
  const { children } = props

  return <header className={styles.container}>{children}</header>
}

Main.displayName = 'Card.Main'
